export const CUSTOMER_STATUS = {
  PROSPECT: 0,
  CUSTOMER: 1,
  PAST_CUSTOMER: 2,
  FOR_APPROVAL: 3,
  LEASING_CUSTOMER: 4,
  DUMMY_CUSTOMER: 9,
}

export const getCustomerStatusTextId = status => `CUSTOMER_STATUS/${status}`

export const getInsuranceTypeTextIdFromCode = code => `INSURANCE_TYPE/${code}`

export const getLeaseProductTypeTextIdFromCode = code => `PRODUCT_TYPE/${code}`
